<template>
    <div>
        <div class="pageback"></div>
        <div class="pagemain">
            <div class="container">
                <div class="row">
                    <div class="col-sm-2" v-if="webW">
                        <div id="JfLeftMenuOut">
                            <div :class="(fixedLeftmenu?'fixedMenuCls':'')"
                                 :style="fixedLeftmenu?('width:'+LeftMenuWidth+'px'):''" id="JfLeftMenu">
                                <div class="baiseback" style="min-height: 100vh;">
                                    <ForumLeft></ForumLeft>
                                </div>

                            </div>
                            <div v-if="fixedLeftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                        </div>


                    </div>
                    <div :class="(webW?'col-sm-10':'col-sm-12')">
                        <TeamTop></TeamTop>


                        <div class="baiseback">
<!--                            <ul class="nav nav-tabs" v-if="(myteaminfo.teamRole==100||myteaminfo.teamRole==50)">-->
<!--                                <li @click="changeAgree('1')" :class="query.isAgree=='1'?'active':''"><a href="#">群成员</a></li>-->
<!--                                <li @click="changeAgree('0')" :class="query.isAgree=='0'?'active':''"><a href="#">进群审核</a></li>-->
<!--                                <li @click="changeAgree('-1')" :class="query.isAgree=='-1'?'active':''"><a href="#">已拒绝</a></li>-->

<!--                            </ul>-->
<!--                            <br>-->



                            <el-row>
                                <el-col :span="webW?4:8">
                                    <el-input v-model="query.unameLike" placeholder="用户名"
                                              class="handle-input mr10"></el-input>
                                </el-col>
                                <el-col :span="webW?4:8">
                                    <el-select v-model="query.teamRole">
                                        <el-option value="" label="全部"></el-option>
                                        <el-option value="1" label="成员"></el-option>
                                        <el-option value="50" label="副群主"></el-option>
                                        <el-option value="100" label="群主"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="8">
                                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                                </el-col>
                                <el-col :span="8" v-if="webW">

                                    <el-switch
                                            @click="openAutoReflashFunc"
                                            style="float: right;"
                                            active-text="下拉刷新"
                                            v-model="openAutoReflash"
                                            active-color="#13ce66"
                                            inactive-color="#dddddd">
                                    </el-switch>
                                </el-col>
                            </el-row>



                            <div class="row margintop20">
                                <div :class="query.isAgree=='1'?'col-sm-4':'col-sm-12'" v-for="(t,i) in tableData" :key="i">
                                    <div class="media kuangkk" >
                                        <div class="media-left">
                                            <img @click="goUHome(t.manageUid)" decoding="async" :src="t.faceimg" class="media-object ffceimgte hander" >
                                        </div>
                                        <div class="media-body">
                                            <h5 class="media-heading"><span  @click="goUHome(t.manageUid)" class="  hander">{{t.uname}}</span>
                                                <span v-if="t.isAgree=='1'">
                                                      <el-tag v-if="t.teamRole==1" size="mini">普通成员</el-tag>
                                                    <el-tag v-if="t.teamRole==100" size="mini" type="danger">群主</el-tag>
                                                    <el-tag v-if="t.teamRole==50" size="mini" type="warning">副群主</el-tag>
                                                </span>

                                            </h5>
                                            <p class="typedesc">{{(t.agts==null||t.agts=='')?t.cts:t.agts}}{{t.isAgree=='1'?'进群':''}} </p>
                                            <p>
                                                &nbsp;<el-button
                                                    @click="delhandle(t,i)"
                                                    v-if=" t.teamRole==1&&(myteaminfo.teamRole==100||myteaminfo.teamRole==50)&&t.isAgree!='0'"
                                                    class="pull-right" size="mini" type="danger"><i
                                                    class="fa fa-close"></i> {{t.isAgree=='1'?'移除':'删除'}}  </el-button>
                                                <el-button
                                                        @click="isagreehandle(t,i,'1')"
                                                        v-if="(myteaminfo.teamRole==100||myteaminfo.teamRole==50)&&t.isAgree!='1'"
                                                        class="pull-right" size="mini" type="primary"><i
                                                        class="fa fa-check"></i> 同意进群  </el-button>
                                                <el-button
                                                        @click="isagreehandle(t,i,'-1')"
                                                        v-if="(myteaminfo.teamRole==100||myteaminfo.teamRole==50)&&t.isAgree=='0'"
                                                        class="pull-right" size="mini" type="danger"><i
                                                        class="fa fa-close"></i> 拒绝进群  </el-button>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="center" v-if="tableDataloading">
                                <img src="../../../assets/img/loading.gif">
                                <p class="typedesc">数据加载中....</p>
                            </div>


                            <div class="center" style="height: 100vh;" v-if="!tableDataloading&&tableData.length==0">
                                <img src="../../../assets/img/zwsj.png">
                                <p class="typedesc">暂无数据</p>
                            </div>


                            <div class="center">
                                <el-pagination v-if="webW"
                                               @current-change="handlePageChange"
                                               :current-page="query.pageNo"
                                               :page-size="query.pageSize"
                                               layout="total, prev, pager, next"
                                               :total="pageTotal">
                                </el-pagination>


                            </div>

                            <p class="typedesc center" v-if="tableDataFinish">没有数据了</p>

                            <Footer></Footer>

                        </div>

                        <br>
                        <br>
                        <br>
                        <br>

                    </div>
                </div>
            </div>
        </div>
        <div class="h100"></div>
        <img src="../../../assets/img/top.png" @click="gotopFunc" v-if="scrolltop" class="gotop hander">
    </div>

</template>
<script>

    import {dealResult, getWindowWidth} from '../../../api/common'
    import {delTeamerById, getTeamerPage,agreeOrNotTeamer} from '../../../api';

    import Footer from "../Footer";
    import ForumLeft from "../index/ForumLeft";
    import TeamTop from "./TeamTop";

    export default {
        name: 'Fans',
        components: {
            Footer,
            ForumLeft,
            TeamTop

        },

        data() {
            return {
                webW: true,
                scrolltop: false,
                openAutoReflash: true,

                //菜单固定
                fixedLeftmenu: false,
                LeftMenuWidth: 0,

                fixedRightmenu: false,
                RightMenuWidth: 0,
                lander: {},

                myteaminfo: {},
                Team_typeId: '',


                // 信息
                tableData: [],
                tableDataloading: true,
                tableDataFinish: false,//避免滚动条在最后一直请求

                query: {
                    isAgree:'1',
                    teamRole: '',
                    unameLike: '',
                    pageNo: 1,
                    pageSize: 9,
                    seltype:'cy_or_fqz',
                },
                pageTotal: 0,

            };
        },
        methods: {
            goUHome(uid){
                this.$router.push('Home?type=myforum&authorId='+uid)
            },
            openAutoReflashFunc() {
                if (this.openAutoReflash) this.tableDataFinish = false;
            },
            gotopFunc() {
                if(document.documentElement!=undefined)document.documentElement.scrollTop=0;
                if(document.body!=undefined) document.body.scrollTop=0;
            },
            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.tableData = [];
                this.getTeamerPage();

                this.tableDataFinish = false;

                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;

            },
            handleSearch() {
                this.query.pageNo = 1;
                this.tableData = [];
                this.getTeamerPage()
            },
            changeAgree(isagree){
                this.query.isAgree= isagree;
                this.query.unameLike = '';
                this.query.teamRole = '';
                this.query.pageNo = 1;
                this.tableData = [];
                this.getTeamerPage()
            },
            //获取 分页
            getTeamerPage() {
                this.tableDataloading = true;
                this.tableDataFinish = false;

                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                this.query.typeId = this.Team_typeId;


                getTeamerPage(this.query).then((res) => {
                    this.tableDataloading = false;
                    dealResult(res.data);


                    if (res.data.status == 1) {
                        this.myteaminfo = res.data.obj.myteaminfo;

                        let li = res.data.obj.pageInfo.list;
                        if (li.length == 0) {
                            this.tableDataFinish = true;
                            return;
                        }


                        this.tableData = this.tableData.concat(li);
                        this.pageTotal = res.data.obj.pageInfo.total//该页总共多少条记录

                        if (this.openAutoReflash) {
                            if (res.data.obj.pageInfo.hasNextPage) this.query.pageNo = res.data.obj.pageInfo.nextPage;
                            else this.query.pageNo = this.query.pageNo + 1;
                        }

                        this.fixedmenu();


                    } else {
                        this.tableDataFinish = true;
                        this.$message.error(res.data.msg)
                    }
                })
            },
            delhandle(t,index){
                this.$confirm("确定删除  "+t.uname +" ？ ", "提示", {
                    type: "warning",
                }) .then(() => {
                    this.loading = this.$loading({
                        lock: true,
                        text: "请求中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.5)",
                    });
                    let o={ id:t.id,uid:this.lander.uid,token:this.lander.token}
                    delTeamerById( o).then((res) => {
                        this.loading.close();
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.success(res.data.msg)
                            this.tableData.splice(index,1);
                        } else{
                            this.$message.error(res.data.msg)
                        }
                    })
                });


            },
            isagreehandle(t,index,isagree){
                this.$confirm("确定"+(isagree=='1'?'同意 ':'拒绝 ')+t.uname +" 进群？ ", "提示", {
                    type: "warning",
                }) .then(() => {
                    this.loading = this.$loading({
                        lock: true,
                        text: "请求中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.5)",
                    });
                    let o={ id:t.id,uid:this.lander.uid,token:this.lander.token,isAgree:isagree}
                    agreeOrNotTeamer( o).then((res) => {
                        this.loading.close();
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.success(res.data.msg)
                            this.tableData.splice(index,1);
                        } else{
                            this.$message.error(res.data.msg)
                        }
                    })
                });


            },

            fixedmenu() {

                let JfLeftMenu = document.getElementById('JfLeftMenu');

                let that = this;
                window.onscroll = function () {

                    let t = document.documentElement.scrollTop || document.body.scrollTop;
                    let h = document.documentElement.scrollHeight;
                    let wh = document.documentElement.clientHeight;


                    if (that.webW) {
                        that.LeftMenuWidth = JfLeftMenu.offsetWidth;

                        //t+wh=h

                        //必须写到onscroll里，因为高度是会变化的
                        let leftHeight = JfLeftMenu.offsetHeight;
                        let leftTop = JfLeftMenu.offsetTop;
                        if (t > leftTop + leftHeight) {
                            that.fixedLeftmenu = true;
                        } else {
                            that.fixedLeftmenu = false;
                        }


                    }


                    //出现回到顶部按钮
                    if (t > wh) that.scrolltop = true;
                    else that.scrolltop = false;


                    //滚动条到底部加载数据
                    if (t + wh >= h - 100 && that.openAutoReflash && !that.tableDataFinish) {

                        if (!that.tableDataloading) that.getTeamerPage();
                    }


                }

            },


        }, mounted() {
            this.webW = getWindowWidth() >= 1000 ? true : false;
            this.lander = JSON.parse(this.$store.state.logininfo);

            if (this.$route.query.Team_typeId == undefined) {
                sessionStorage.systip = "该群组不存在";
                this.$router.replace("/Tip");
                return;
            }
            if( this.$route.query.TeamIsagree!=undefined)this.query.isAgree = this.$route.query.TeamIsagree;
            else this.query.isAgree ='1';
            this.Team_typeId = this.$route.query.Team_typeId;
            this.getTeamerPage();

            //固定左右菜单
            this.fixedmenu();

            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;


        }, watch: {
            $route: function (value) {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;

                if (value.query.Team_typeId != undefined  && ( value.query.Team_typeId != this.Team_typeId ||  value.query.TeamIsagree != this.query.isAgree )   ) {


                    this.Team_typeId = value.query.Team_typeId;
                    if(value.query.TeamIsagree !=undefined)this.query.isAgree = value.query.TeamIsagree;
                    else this.query.isAgree ='1';
                    this.tableData=[];

                    this.query.pageNo=1;
                    this.query.unameLike='';
                    this.query.teamRole='';
                    this.getTeamerPage();
                }
            }
        },
        activated() {


            //固定左右菜单
            this.fixedmenu();


        },
        deactivated() {

        }

    };
</script>
<style scoped>
    .mr10 {
        margin-right: 10px;
        width: 100%;
    }
    .kuangkk{border: 1px solid #f3f3f3;border-radius: 10px;margin: 10px;padding: 10px}
    .ffceimgte{width:60px;height: 60px;border-radius: 50%;background-color: #f3f3f3;}
</style>
